module.exports = __webpack_public_path__ + "img/UOB.fa1b7eed.png";